import {
    TableHead,
    TableRow,
} from "@material-ui/core";
import {
    React,
    useEffect,
    clsx,
    api
} from '../../../barrelFiles/basicBarrelFile';
import { MyTableCell } from "../../../styling/Styles";
import FilterComp from './FilterComp';


//  This const contains all the info of head cells inside head row.
const headCells = [
    { id: 'showHide', numeric: false, label: ''},
    { id: "name", numeric: false, label: "Name" },
    { id: "date", numeric: false,  label: "Last edit" },
    { id: "role", numeric: false, label: "Role" },
    { id: 'numberPages', numeric: false,  label: "Number of pages"},
    { id: 'backEndQuality', numeric: false, label: "Back-end quality"},
    { id: 'frontEndQuality', numeric: false, label: 'Front-end quality'},
    { id: 'status', numeric: false, label: 'Status'},
    { id: 'actions', numeric: false, label: 'Actions'}
];

// This component is renders the head row of home's project's table.
const EnhancedTableHead = (props) => {

    const { onRequestSort, setFilterStatus, setFilterRole, setFilterShow, response, order, filterBy, setFilterBy } = props;
    const stateFilterOptions = ['Show all', 'Show active', 'Show suspended'];
    const roleFilterOptions = ['Show all','Show owner', 'Show member'];
    const showFilterOptions = ['Show all', 'Show visible', 'Show non visible'];
    const [init, setInit] = React.useState(false);


    /**
     * This useEffect is runned when we load the enhancedTableHead component for the first time 
     * and the response that we take as prop from higher component is not undefined. It initiates 
     * the filter statuses and then it locks the condition.
     */
    useEffect( () => {

        if(init === false && response !== undefined){

            setFilterRole(response.data.roleFilter);
            setFilterStatus(response.data.statusFilter);
            setFilterShow(response.data.visibilityFilter);
            setInit(true);
        }

    },[init,response])

    return (
        <TableHead className={clsx("blueLabel")}>
            <TableRow>
            {headCells.map(headCell => (
                <MyTableCell
                key={headCell.id}
                align="center"   
                className={headCell.id !== "actions" ? 'headerCellStyle' : 'actionsHeaderStyle'}                 
                >
                    {headCell.id === 'showHide' && <HeaderShowHideCell setFilter = {setFilterShow}  filterOptions={showFilterOptions} response={response}/>}
                    {headCell.id === 'name' && <HeaderSortCell headCell={headCell} onRequestSort={onRequestSort} filterBy={filterBy} setFilterBy={setFilterBy} order={order}/> }
                    {headCell.id === 'quality' && <HeaderLabelCell headCell={headCell} />}
                    {headCell.id === 'date' && <HeaderSortCell headCell={headCell} onRequestSort={onRequestSort} filterBy={filterBy} setFilterBy={setFilterBy} order={order}/>}
                    {headCell.id === 'role' && <HeaderFilterCell headCell={headCell} setFilter={setFilterRole} filterOptions={roleFilterOptions} response={response}/>}
                    {headCell.id === 'numberPages' && <HeaderLabelCell headCell={headCell} />}
                    {headCell.id === 'backEndQuality' && <HeaderLabelCell headCell={headCell} />}
                    {headCell.id === 'frontEndQuality' && <HeaderLabelCell headCell={headCell} />}
                    {headCell.id === 'status'  && <HeaderFilterCell headCell={headCell} setFilter={setFilterStatus} filterOptions={stateFilterOptions} response={response}/>}
                    {headCell.id === 'actions' && <HeaderLabelCell headCell={headCell} />}
                </MyTableCell>
                
            ))}
            </TableRow>
        </TableHead>
    );

}

/**
 * This component returns the header show-hide label. It contains 
 * of a show-hide image and a dropdown component next to it which 
 * filters the projects based on show-hide options.
 */
const HeaderShowHideCell = ({setFilter, filterOptions,response}) => {
    
    const  updateFilter = (option) => {
        api.updateUser({userPreferences : { 
            visibilityFilter: option, 
            hiddenProjects: response.data.hiddenProjects,  
            roleFilter: response.data.roleFilter,
            statusFilter: response.data.statusFilter
        } });
    }
    
    return(
        <>
            <i className={clsx('fas', 'fa-eye', 'fa-eye2')} />
            &nbsp; &nbsp;
            <FilterComp
                setFilter = {setFilter}
                filterOptions = {filterOptions}
                updateFilter={updateFilter}
            />
        </>
    )
    
}

/**
 *  This component returns the sort header label.It contains a 
 *  header label and a sort image next to it. If we click on 
 *  sort image we sort all the projects based on the order that
 *  we have select (descending/ ascending).
 */
const HeaderSortCell = ({headCell, onRequestSort, filterBy, setFilterBy, order}) => {
    
    //  This function sort the project based on the order that we have select.
    const createSortHandler = property => () => {
        onRequestSort(property);
        setFilterBy(property);
    };
    
    return(
    <div
        onClick={createSortHandler(headCell.id)}
        className={clsx("teamSelector", "inline")}
        id='headerNameCell'
        aria-hidden="true"
    >
        {headCell.label}
        &nbsp; &nbsp; 
        {
            filterBy === headCell.id && 
            ( order === 'asc' ?
                <span className={clsx('sort-asc','sort-icon')}/>
                :
                <span className={clsx('sort-desc','sort-icon')}/>
            )
        }
    </div>
    )
}

// This component returns a header label cell
const HeaderLabelCell = ({headCell}) => (
    <span>
        {headCell.label}
    </span>
)

/**
 * This component returns a header label cell and a filter component.
 * The choice on the filter component leads to what user sees in the 
 * column below. 
*/
const HeaderFilterCell = ({headCell, setFilter, filterOptions,response}) => {

    const updateFilter = (option) => {
        if(headCell.id === 'role'){
            api.updateUser({
                userPreferences : 
                    { 
                        roleFilter: option,
                        hiddenProjects: response.data.hiddenProjects,
                        visibilityFilter: response.data.visibilityFilter,
                        statusFilter: response.data.statusFilter
                    } 
            });
        }
        else if(headCell.id === 'status'){
            api.updateUser({
                userPreferences : 
                { 
                    statusFilter: option, 
                    roleFilter: response.data.roleFilter,
                    hiddenProjects: response.data.hiddenProjects,
                } 
            
            });
        }   
    }

    return(
        <>
            {headCell.label}
            &nbsp; &nbsp;
            <FilterComp
                setFilter = {setFilter}
                filterOptions = {filterOptions}
                updateFilter={updateFilter}
            />
        </>
    )
}

export default EnhancedTableHead;